export const TRANSACTION_SOURCE = {
  HOLDINGS: 'holdings',
  TRANSACTION: 'transaction',
  EXPLORE: 'explore',
  MUTUAL_FUND: 'mutualFund',
};
export const TRANSACTION_TYPE = {
  SIP: 'SIP',
  SWITCH: 'Switch',
  REDEEM: 'Redeem',
  INVEST: 'Invest',
  STP: 'STP',
  SWP: 'SWP',
  FULL_REDEMPTION: 'Full Redemption',
  PARTIAL_REDEMPTION: 'Partial Redemption',
  FULL_SWITCH: 'Full Switch',
  PARTIAL_SWITCH: 'Partial Switch',
  STP_CANCEL: 'STP Cancel',
  SIP_CANCEL: 'SIP Cancel',
  SWP_CANCEL: 'SWP Cancel',
};
export const TRANSACTION_STATUS = { CANCELLED: 'Cancelled', PENDING: 'Pending', INPROGRESS: 'In-progress' };
export const CONGRATULATIONS = 'CONGRATULATIONS!';
export const TRANSACTION_SUCCESS_MESSAGE = 'Your transaction is successful and your request has been submitted.';

// For redeem request page
export const SUCCESS = 'SUCCESS';
export const SUCCESSFUL = 'SUCCESSFUL';
export const REDEEM_SUCCESS_MESSAGE = 'Your transaction is successful and your redemption request has been submitted';
export const SWP_SUCCESS_MESSAGE = 'Your transaction is successful and your systematic withdrawal request has been submitted.'
// For switch request page
export const SWITCH_SUCCESS_MESSAGE = 'Your transaction is successful and your switch request has been submitted.';
export const STP_SUCCESS_MESSAGE = 'Your transaction is successful and your systematic transfer request has been submitted.'

// For SIP cancellation page
export const SIP_CANCEL_SUCCESS_MESSAGE = 'Your SIP cancellation request has been submitted successfully';

// For STP cancellation page
export const STP_CANCEL_SUCCESS_MESSAGE = 'Your STP cancellation request has been submitted successfully';

export const SWP_CANCEL_SUCCESS_MESSAGE = 'Your SWP cancellation request has been submitted successfully';
export const cancellationDisclaimerMessage = '';
export const transactionDisclaimerMessage =
  'We will be forwarding the transaction details to AMC/RTA for further processing which may take 2- 3 working days. Your portfolio will be updated post transaction confirmation from AMC/RTA.';
export const SIPtransactionDisclaimerMessage =
  `For all the SIP transactions executed after cut off timings, the amount will get debited from your account the next business day and transaction details will be forwarded to AMC/RTA for further processing which may take 2-3 working days. Your portfolio will be updated post transaction confirmation from AMC/RTA. Please visit the ‘Past Transactions’ section once the money gets debited.`;
export const GO_BACK_TO_HOLDINGS = 'Back to My Holdings';
export const BACK_TO_TRANSACTIONS = 'Back to Transactions';
export const MUTUAL_FUND_HOME = 'Mutual Fund Home';
export const EXPLORE_OTHER_FUNDS = 'Explore Other Funds';
export const actionButtons = [
  {
    label: 'Action 1',
    onPress: () => {},
  },
  {
    label: 'Action 2',
    onPress: () => {},
  },
];

export const SCHEME_OPTION_MAPPING = {
  Growth: 'Growth',
  Payout: 'Payout',
  'Re-Investment': 'Reinvestment',
};

export const TERMS_AND_CONDITIONS = 'Terms & Conditions';
